import React from "react";
import { Container } from "react-bootstrap";
import "./Details.css";

export default function Details() {
  return (
    <div>
      <Container className="py-5">
        <p className="custom-bold">MITx</p>
        <h3 className="boldness">
          Free online courses from Massachusetts Institute of Technology
        </h3>
        <p className="custom-p">
          Massachusetts Institute of Technology — a coeducational, privately
          endowed research university founded in 1861 — is dedicated to
          advancing knowledge and educating students in science, technology, and
          other areas of scholarship that will best serve the nation and the
          world in the 21st century. Learn more about MIT. Through MITx, the
          Institute furthers its commitment to improving education worldwide.
        </p>

        <h3 className="boldness">MITx Courses</h3>
        <p className="custom-p">
          MITx courses embody the inventiveness, openness, rigor and quality
          that are hallmarks of MIT, and many use materials developed for MIT
          residential courses in the Institute's five schools and 33 academic
          disciplines. Browse MITx courses below.
        </p>

        <h3 className="boldness">
          Massachusetts Institute of Technology MOOCs
        </h3>
        <p className="custom-p">
          Browse free online courses in a variety of subjects. Massachusetts
          Institute of Technology courses found below can be audited free or
          students can choose to receive a verified certificate for a small fee.
          Select a course to learn more.
        </p>
      </Container>
    </div>
  );
}
